import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';

export abstract class IApiRouteService {
  protected readonly http = inject(HttpClient);
  protected abstract urlRoute: string;
}
